import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { PromptUpdateService } from './core/services/sw/prompt-update.service';
import { LogUpdateService } from './core/services/sw/log-update.service';
import { HandleUnrecoverableStateService } from './core/services/sw/handle-unrecoverable-state.service';
import { CheckForUpdateService } from './core/services/sw/check-for-update.service';
import { Component, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import packageInfo from '../../package.json';
import { AccountService } from './core/services/account.service';
import { MessageService } from './core/services/message.service';
import { AngularPlugin } from '@microsoft/applicationinsights-angularplugin-js';
import { environment } from 'src/environments/environment';
import { SpinnerComponent } from './spinner/spinner.component';
import { NavBarComponent } from './nav-bar/nav-bar.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [SpinnerComponent, NavBarComponent, RouterOutlet, AsyncPipe]
})
export class AppComponent {
  private router = inject(Router);
  accountService = inject(AccountService);
  messageService = inject(MessageService);
  CheckForUpdateService = inject(CheckForUpdateService);
  HandleUnrecoverableStateService = inject(HandleUnrecoverableStateService);
  LogUpdateService = inject(LogUpdateService);
  PromptUpdateService = inject(PromptUpdateService);

  public version: string = packageInfo.version; //version;
  public environmentName = environment.name;

  appInsigtsSetup() {
    const angularPlugin = new AngularPlugin();
    const appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: '3c8975bd-ea44-4560-b9f2-30ee9a475812',
        extensions: [angularPlugin],
        extensionConfig: {
          [angularPlugin.identifier]: { router: this.router }
        }
      }
    });
    appInsights.loadAppInsights();
  }


}
